import { PERSONA_TYPES } from '../../console/_statics/persona.statics';
import { useAuth } from './useAuth';

export const ZURICH_CARRIER_PREFIX = 'ZUR';

export const useIsZurichCarrier = () => {
  const { accountType, carrierPrefix } = useAuth();
  return (
    accountType === PERSONA_TYPES.CARRIER &&
    carrierPrefix === ZURICH_CARRIER_PREFIX
  );
};
